import { useEffect, useState } from 'react';
import { api } from '../lib/api';

export default function Claims() {
  const [claims, setClaims] = useState([]);
  const [selected, setSelected] = useState(null);

  const load = () => api.getClaims().then(setClaims).catch((err) => console.error('Failed to load claims:', err));
  useEffect(() => { load(); }, []);

  const updateStatus = async (id, status) => {
    try {
      await api.updateClaim(id, { status });
      load();
      if (selected?.id === id) setSelected({ ...selected, status });
    } catch (err) {
      console.error('Failed to update claim:', err);
    }
  };

  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Claims</h1>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 bg-white rounded-lg shadow overflow-hidden">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Guest</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Amount</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {claims.map((claim) => (
                <tr key={claim.id} className="cursor-pointer hover:bg-gray-50" onClick={() => setSelected(claim)}>
                  <td className="px-6 py-4 text-sm text-gray-900">{claim.guest_name}</td>
                  <td className="px-6 py-4 text-sm text-gray-900">${claim.amount != null ? claim.amount.toFixed(2) : '—'}</td>
                  <td className="px-6 py-4">
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${claimStatusColor(claim.status)}`}>
                      {claim.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 flex gap-2" onClick={(e) => e.stopPropagation()}>
                    {claim.status === 'draft' && (
                      <button onClick={() => updateStatus(claim.id, 'pending_approval')} className="text-xs text-blue-600 hover:text-blue-800">Submit</button>
                    )}
                    {claim.status === 'pending_approval' && (
                      <>
                        <button onClick={() => updateStatus(claim.id, 'approved')} className="text-xs text-green-600 hover:text-green-800">Approve</button>
                        <button onClick={() => updateStatus(claim.id, 'rejected')} className="text-xs text-red-600 hover:text-red-800">Reject</button>
                      </>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="lg:col-span-1 bg-white rounded-lg shadow p-6">
          {selected ? (
            <div>
              <h2 className="text-lg font-semibold text-gray-900 mb-4">Claim Details</h2>
              <dl className="space-y-3">
                <div><dt className="text-xs text-gray-500 uppercase">Guest</dt><dd className="text-sm text-gray-900">{selected.guest_name}</dd></div>
                <div><dt className="text-xs text-gray-500 uppercase">Property</dt><dd className="text-sm text-gray-900">{selected.property_name}</dd></div>
                <div><dt className="text-xs text-gray-500 uppercase">Platform</dt><dd className="text-sm text-gray-900">{selected.platform}</dd></div>
                <div><dt className="text-xs text-gray-500 uppercase">Amount</dt><dd className="text-sm text-gray-900">${selected.amount != null ? selected.amount.toFixed(2) : '—'}</dd></div>
                <div><dt className="text-xs text-gray-500 uppercase">Reason</dt><dd className="text-sm text-gray-900">{selected.reason}</dd></div>
                <div><dt className="text-xs text-gray-500 uppercase">Status</dt><dd className="text-sm"><span className={`px-2 py-1 rounded-full text-xs font-medium ${claimStatusColor(selected.status)}`}>{selected.status}</span></dd></div>
              </dl>
            </div>
          ) : (
            <p className="text-gray-400 text-center py-8">Select a claim to view details</p>
          )}
        </div>
      </div>
    </div>
  );
}

function claimStatusColor(status) {
  const map = {
    draft: 'bg-gray-100 text-gray-800',
    pending_approval: 'bg-amber-100 text-amber-800',
    approved: 'bg-green-100 text-green-800',
    rejected: 'bg-red-100 text-red-800',
    sent: 'bg-blue-100 text-blue-800',
  };
  return map[status] || 'bg-gray-100 text-gray-800';
}
